import React, { Component } from 'react';
import { parseString } from 'xml2js';
import { path } from 'ramda';
import Translate from 'react-translate-component';
import { Button } from 'antd';

export default class DocumentXMLResume extends Component {
    state = {
        url: null
    }

    componentDidMount() {
        const { body } = this.props;

        parseString(body.replace(/&/g, '&amp;'), (err, { root }) => {
            if (!root) return;
            const url = path(['url', 0], root);

            this.setState({ url: url.replace(/&amp;/g, '&')});
        });
    }

    openVCVTab = () => {
        const { url } = this.state;

        if (url) {
            window.open(url, '_blank', 'noopener', 'noreferrer');
        }
    }

    render() {
        if (!this.state.url) {
            return null;
        }

        return (
            <Button onClick={this.openVCVTab}>
                <Translate content="documents.openVcv" />
            </Button>
        );
    }
}
